import { MarketingMessage } from './MarketingMessage';
import icon_energy_off from '../../assets/icon_state_off.svg';

export const MarketingMessageEnergy = () => {
  return (
    <MarketingMessage heading="Energy" icon={icon_energy_off} showContact={true}>
      <>
        <p>There are no grid meters to display. Contact Elexity for more information.</p>
      </>
    </MarketingMessage>
  );
};
